var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            [
              _c(
                "Card",
                [
                  _c(
                    "Row",
                    [
                      _c(
                        "Form",
                        {
                          ref: "searchForm",
                          staticClass: "search-form",
                          attrs: {
                            model: _vm.searchForm,
                            inline: "",
                            "label-width": 70
                          }
                        },
                        [
                          _c(
                            "Form-item",
                            { attrs: { label: "标题", prop: "title" } },
                            [
                              _c("Input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.searchForm.title,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "title", $$v)
                                  },
                                  expression: "searchForm.title"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            { attrs: { label: "状态", prop: "status" } },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.searchForm.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.searchForm, "status", $$v)
                                    },
                                    expression: "searchForm.status"
                                  }
                                },
                                [
                                  _c("Option", { attrs: { value: "0" } }, [
                                    _vm._v("草稿")
                                  ]),
                                  _vm._v(" "),
                                  _c("Option", { attrs: { value: "1" } }, [
                                    _vm._v("处理中")
                                  ]),
                                  _vm._v(" "),
                                  _c("Option", { attrs: { value: "1" } }, [
                                    _vm._v("已结束")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            { attrs: { label: "结果", prop: "result" } },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.searchForm.result,
                                    callback: function($$v) {
                                      _vm.$set(_vm.searchForm, "result", $$v)
                                    },
                                    expression: "searchForm.result"
                                  }
                                },
                                [
                                  _c("Option", { attrs: { value: "0" } }, [
                                    _vm._v("未提交")
                                  ]),
                                  _vm._v(" "),
                                  _c("Option", { attrs: { value: "1" } }, [
                                    _vm._v("处理中")
                                  ]),
                                  _vm._v(" "),
                                  _c("Option", { attrs: { value: "2" } }, [
                                    _vm._v("通过")
                                  ]),
                                  _vm._v(" "),
                                  _c("Option", { attrs: { value: "3" } }, [
                                    _vm._v("驳回")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("DatePicker", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  type: "daterange",
                                  format: "yyyy-MM-dd",
                                  clearable: "",
                                  placeholder: "选择起始时间"
                                },
                                on: { "on-change": _vm.selectDateRange },
                                model: {
                                  value: _vm.selectDate,
                                  callback: function($$v) {
                                    _vm.selectDate = $$v
                                  },
                                  expression: "selectDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            {
                              staticClass: "br",
                              staticStyle: { "margin-left": "-35px" }
                            },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "ios-search"
                                  },
                                  on: { click: _vm.handleSearch }
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _c("Button", { on: { click: _vm.handleReset } }, [
                                _vm._v("重置")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    { staticClass: "operation" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary", icon: "md-add" },
                          on: { click: _vm.add }
                        },
                        [_vm._v("新增申请")]
                      ),
                      _vm._v(" "),
                      _c(
                        "Button",
                        {
                          attrs: { icon: "md-trash" },
                          on: { click: _vm.delAll }
                        },
                        [_vm._v("批量删除")]
                      ),
                      _vm._v(" "),
                      _c(
                        "Button",
                        {
                          attrs: { icon: "md-refresh" },
                          on: { click: _vm.getDataList }
                        },
                        [_vm._v("刷新")]
                      ),
                      _vm._v(" "),
                      _vm.operationLoading ? _c("circleLoading") : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    [
                      _c("Alert", { attrs: { "show-icon": "" } }, [
                        _vm._v("\n                        已选择"),
                        _c("span", { staticClass: "select-count" }, [
                          _vm._v(_vm._s(_vm.selectCount))
                        ]),
                        _vm._v(" 项\n                        "),
                        _c(
                          "a",
                          {
                            staticClass: "select-clear",
                            on: { click: _vm.clearSelectAll }
                          },
                          [_vm._v("清空")]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    [
                      _c("Table", {
                        ref: "table",
                        attrs: {
                          loading: _vm.loading,
                          border: "",
                          columns: _vm.columns,
                          data: _vm.data,
                          sortable: "custom"
                        },
                        on: { "on-selection-change": _vm.showSelect }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    {
                      staticClass: "page",
                      attrs: { type: "flex", justify: "end" }
                    },
                    [
                      _c("Page", {
                        attrs: {
                          current: _vm.searchForm.pageNumber,
                          total: _vm.total,
                          "page-size": _vm.searchForm.pageSize,
                          "page-size-opts": [10, 20, 50],
                          size: "small",
                          "show-total": "",
                          "show-elevator": "",
                          "show-sizer": ""
                        },
                        on: {
                          "on-change": _vm.changePage,
                          "on-page-size-change": _vm.changePageSize
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          attrs: { title: "选择申请", closable: "", width: "800" },
          model: {
            value: _vm.processModalVisible,
            callback: function($$v) {
              _vm.processModalVisible = $$v
            },
            expression: "processModalVisible"
          }
        },
        [
          _c("div", { staticClass: "apply-operation" }, [
            _c(
              "div",
              [
                _c(
                  "Form",
                  {
                    ref: "searchProcessForm",
                    staticClass: "search-form",
                    attrs: {
                      model: _vm.searchProcessForm,
                      inline: "",
                      "label-width": 65
                    }
                  },
                  [
                    _c(
                      "Form-item",
                      { attrs: { label: "流程名称", prop: "name" } },
                      [
                        _c("Input", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            type: "text",
                            clearable: "",
                            placeholder: "请输入流程名"
                          },
                          model: {
                            value: _vm.searchProcessForm.name,
                            callback: function($$v) {
                              _vm.$set(_vm.searchProcessForm, "name", $$v)
                            },
                            expression: "searchProcessForm.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Form-item",
                      {
                        staticClass: "br",
                        staticStyle: { "margin-left": "-35px" }
                      },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary", icon: "ios-search" },
                            on: { click: _vm.getProcessList }
                          },
                          [_vm._v("搜索")]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          { on: { click: _vm.handleResetProcess } },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "RadioGroup",
                  {
                    attrs: { type: "button" },
                    model: {
                      value: _vm.showType,
                      callback: function($$v) {
                        _vm.showType = $$v
                      },
                      expression: "showType"
                    }
                  },
                  [
                    _c(
                      "Radio",
                      { attrs: { title: "缩略图", label: "thumb" } },
                      [
                        _c("Icon", {
                          staticStyle: { "margin-bottom": "3px" },
                          attrs: { type: "ios-apps" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Radio",
                      { attrs: { title: "列表", label: "list" } },
                      [
                        _c("Icon", {
                          staticStyle: { "margin-bottom": "3px" },
                          attrs: { type: "md-list" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.showType == "thumb"
            ? _c(
                "div",
                { staticClass: "process-wrapper" },
                [
                  _vm._l(_vm.processData, function(item, i) {
                    return _c("Card", { key: i, staticClass: "process-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "content",
                          on: {
                            click: function($event) {
                              _vm.chooseProcess(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "other" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(i + 1) + ". " + _vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "key" }, [
                              _vm._v(_vm._s(item.description))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info" }, [
                              _vm._v(
                                "\n                            版本：v." +
                                  _vm._s(item.version) +
                                  " 所属分类：" +
                                  _vm._s(item.categoryTitle) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _vm.processLoading
                    ? _c("Spin", { attrs: { fix: "" } })
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showType == "list"
            ? _c("Table", {
                ref: "processTable",
                attrs: {
                  loading: _vm.processLoading,
                  border: "",
                  columns: _vm.processColumns,
                  data: _vm.processData
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: { title: "提交申请", "mask-closable": false, width: 500 },
          model: {
            value: _vm.modalVisible,
            callback: function($$v) {
              _vm.modalVisible = $$v
            },
            expression: "modalVisible"
          }
        },
        [
          _c(
            "Form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": 85,
                rules: _vm.formValidate
              }
            },
            [
              _c(
                "FormItem",
                {
                  staticStyle: { position: "relative" },
                  attrs: { label: "选择审批人", prop: "assignee" }
                },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        placeholder: "请选择或输入搜索",
                        filterable: "",
                        clearable: "",
                        loading: _vm.userLoading
                      },
                      model: {
                        value: _vm.form.assignee,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "assignee", $$v)
                        },
                        expression: "form.assignee"
                      }
                    },
                    _vm._l(_vm.assigneeList, function(item, i) {
                      return _c(
                        "Option",
                        { key: i, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.username))]
                      )
                    })
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "优先级", prop: "priority" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.form.priority,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "priority", $$v)
                        },
                        expression: "form.priority"
                      }
                    },
                    _vm._l(_vm.dictPriority, function(item, i) {
                      return _c(
                        "Option",
                        { key: i, attrs: { value: item.value } },
                        [_vm._v(_vm._s(item.title))]
                      )
                    })
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "text" }, on: { click: _vm.handelCancel } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handelSubmit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-withdraw-modal", {
        attrs: {
          modalCancelVisible: _vm.modalCancelVisible,
          id: _vm.cancelForm.id,
          businessType: "contract",
          procInstId: _vm.cancelForm.procInstId
        },
        on: { cancel: _vm.cancelWithDraw, refresh: _vm.getDataList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }